import { Component, OnInit, OnDestroy, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { MatSelectChange } from '@angular/material/select';
import { Subscription } from 'rxjs';
import { MatSidenav } from '@angular/material/sidenav';

import { ContextService } from '../core/context.service';
import { UserService } from '../services/user.service';
import { TranslatorService } from '../core/translator.service';
import { Formats } from '../core/constants';
import { AuthorisationService } from '../services/authorisation.service';
import { BranchService } from '../services/branch.service';
import { BankService } from '../services/bank.service';

@Component({
  selector: 'tv-header',
  templateUrl: './header.component.html',
  styleUrls: [
    './header.component.css'
  ]
})
export class HeaderComponent implements OnInit, OnDestroy, OnChanges {
  @Input() sideNav: MatSidenav;

  languages = [
    { displayText: 'ಭಾಷೆ/Language', value: 'en' },
    { displayText: 'English', value: 'en' },
    { displayText: 'አማርኛ', value: 'am' }
  ];

  selectedLanguage: string;
  selectedBranchId: number;
  isLoggedIn: boolean;
  branches: Array<any>;
  homeBranch: any;
  currentBranch: any;
  currentDate: Date;
  loggedInUserName: string;
  bankName: string;
  authorisationCount = 0;
 isHeadOffice: boolean;
branchMaster: any;
  private contextChangedSubscription: Subscription;
  bankdetails: any;
  erprequired: any;
  erpLink: any;
  erpd: any;
  showIconSelector = false;
  showAllIcon = false;
  nameroleId: any;
  // roleId: any;
  // nameroleId: any;
  constructor(private contextService: ContextService,
    private translatorService: TranslatorService,
    private authorisationService: AuthorisationService,
    private router: Router,
    private userService: UserService,
    private branchService: BranchService,
    private bankService:BankService,
    private formats: Formats) {
      // this.bankService.getBank()
      // .subscribe(resultReqd => {
      // this.erprequired = resultReqd.bank.erpRequired;
      // this.erpLink = resultReqd.bank.erpLink;
      // console.log('erpRequired:', this.erprequired);
      // //this.currency=resultReqd.bankSetting.bankCurrency;
      // });
  
  }

  ngOnInit() {
  this.selectedLanguage = this.translatorService.CurrentLanguage || this.translatorService.DefaultLanguage;
  this.contextChangedSubscription = this.contextService.contextChanged.subscribe(() => this.initialise());
  const loggedInUser = this.contextService.user; 
  
    this.initialise();
}

  ngOnDestroy() {
    console.log('Unsubscribing contextChangedSubscription');
    this.contextChangedSubscription.unsubscribe();
  }

  ngOnChanges() {
    this.authorisationService.getPendingItemsCount()
      .subscribe(res => {
        this.authorisationCount = res.maintenanceCount + res.transactionCount;
        console.log('maintenance authorisation count in header', res);
      });
  }

  private initialise() {
    const loggedInUser = this.contextService.user;
    this.isLoggedIn = this.contextService.isLoggedIn;
    const unionId = this.contextService.user?.unionId;
  const roleId = this.contextService.user?.currentBranchPermissions?.roleId;


    this.loggedInUserName = '';
    this.authorisationService.getPendingItemsCount()
      .subscribe(res => {
        this.authorisationCount = res.maintenanceCount + res.transactionCount;
        console.log('maintenance authorisation count in header', res);
      });
    console.log('logged in user data in header', loggedInUser);
    if (this.isLoggedIn === true) {
      this.bankService.getBank()
    .subscribe(resultReqd => {
    this.erprequired = resultReqd.bank.erpRequired;
    this.erpLink = resultReqd.bank.erpLink;
    console.log('erpRequired:', this.erprequired);
    //this.currency=resultReqd.bankSetting.bankCurrency;
    });
      this.bankName = loggedInUser.bankName;
      this.loggedInUserName = loggedInUser.userName;
      this.homeBranch = this.contextService.homeBranch;
      this.currentBranch = this.contextService.currentBranch;
      //this.currentDate = new Date();
      this.currentDate = this.contextService.currentDate;
      const roleIddata = this.contextService.user?.currentBranchPermissions?.roleId;
  this.nameroleId = roleIddata;
   this.bankName = this.contextService.user.bankName;
      this.branches = [this.homeBranch];
      this.selectedBranchId = this.currentBranch.id;
      this.erpd= this.contextService.erp;   
    }
    console.log('Raw contextService.currentDate:', this.contextService.currentDate);
console.log('Parsed currentDate:', this.currentDate);

    console.log('Current date is ', this.currentDate, this.contextService.currentDate);

    if (unionId === 0 && roleId === 1) {
      this.showIconSelector = true;
    } else if (unionId > 0) {
      this.showIconSelector = true; 
    }
    else {
      this.showIconSelector = false;
    }

    
  }

  onBranchChange(selectChange: MatSelectChange) {
    const branchId = selectChange.value;
    this.branchService.getBranchSettings(branchId).subscribe(
      result => {
        this.contextService.setCurrentBranchSettings(result);
        this.contextService.setCurrentBranch(branchId);
      },
      error => console.log('Failed to get branch setting', error));
  }

  // getBranchHeadOffice(branchId : number){
  //   this.branchService.getBranchById(branchId)
  //   .subscribe(resultReqd => {
  //     const branchMaster = resultReqd;
  //     this.isHeadOffice=branchMaster.branchSettings.isHeadOffice;
  //     console.log('this.branchMaster--',this.branchMaster);

  //   });
  // }

  


  onLanguageChange(selectChange: MatSelectChange) {
    this.translatorService.CurrentLanguage = selectChange.value;
  }

  logout(): void {
    this.userService.logout();

    this.isLoggedIn = false;
    this.loggedInUserName = null;
    this.homeBranch = null;
    this.currentBranch = null;
    this.currentDate = null;
    this.branches = [];
    this.selectedBranchId = -1;
    this.sideNav.close();

    this.router.navigate(['/login']);
  }

  goToHome() {
    this.router.navigate(['/home']);
  }
  // goToVista() {
  //   this.router.navigate(['/accountstatement']);
  // }
    goToVista() {
    this.router.navigate(['/accountstatementall']);
  }
  goToLoanCalculator() {
    this.router.navigate(['/loanaccount/loancalculator']);
  }
  goToLoanAccountStatement() {
    this.router.navigate(['/reports/loanaccountstatement']);
  }
  goToCash() {
    this.router.navigate(['/transaction/cash']);
  }
  goToTransfer() {
    this.router.navigate(['/transaction/transfer']);
  }
   goToChangeBranch() {
    this.router.navigate(['/branch/changebranch']);
  }
  // gotoErpStatement() {
  //   window.open('https://oacf.sybylcloud.com/web/login');
  //  // window.open('https://sybyl-cloud-cbs-integration-odoo-17-task5738-test-14680149.dev.odoo.com/web#id=22&cids=1&menu_id=250&action=254&active_id=5&model=account.move&view_type=form');
  //   //this.router.navigate(['https://sybyl-cloud-cbs-integration-odoo-17-task5738-test-14680149.dev.odoo.com/web#id=22&cids=1&menu_id=250&action=254&active_id=5&model=account.move&view_type=form'])
  // }

  gotoErpStatement(): void {
    if (this.erpLink) {
      window.open(this.erpLink);  // Opens the link in a new tab
    }
  }
  goToDashboard(){
    this.router.navigate(['/reports/dashboard']);
  }
  goToDashboarddata(){
    this.router.navigate(['/reports/dashboarddata']);
  }
}
